
import '../../styles/Concurso.css';

/*Iconos*/
import Casco_icon from '../../imagenes/icons/casco.gif';
import brocoli_icon from '../../imagenes/icons/brocoli.gif';
import Bases_icon from '../../imagenes/icons/bases.gif';
import Anexos_icon from '../../imagenes/icons/anexos.gif';
import Comunicado_icon from '../../imagenes/icons/comunicado.gif';
import FeErratas_icon from '../../imagenes/icons/feErratas.gif';
import EvaCV_icon from '../../imagenes/icons/evaluacion.gif';
import Entrevista_icon from '../../imagenes/icons/entrevista.gif';
import ResultFinal_icon from '../../imagenes/icons/resultados.gif';

/*Documentos*/
import Bases_pdf from '../../documentos/concursos/frutiverdura/BASES_FRUTI_VERDURA.pdf';
import Anexos_doc from '../../documentos/CAS/CASV2025/ANEXOS.docx';
import Comunicado_01_pdf from '../../documentos/CAS/CASV2025/COMUNICADO_CAS_V_01_2025.pdf';
import Comunicado_02_pdf from '../../documentos/CAS/CASIII2025/COMUNICADO_CAS_III_02_2025.pdf';
import Fe_Erratas_01_pdf from '../../documentos/CAS/CASV2025/FE_DE_ERRATAS_01_2025.pdf';
import Fe_Erratas_02_pdf from '../../documentos/CAS/CASIV2025/FE_DE_ERRATAS_02_2025.pdf';
import Result_CV_pdf from '../../documentos/CAS/CASV2025/RESULTADOS_DE_EVALUACION_CURRICULAR_05_2025.pdf';
import Cronograma_pdf from '../../documentos/CAS/CASV2025/CRONOGRAMA_DE_ENTREVISTA_05_2025.pdf';
import ResultFinal_pdf from '../../documentos/concursos/frutiverdura/RESULTADOS_FINALES.pdf';

function ConcursoFutriVerdura2025(){
  const documentos=[
    {
      titulo: 'Bases del Concurso 2025',
      icon: Bases_icon,
      nombre: 'Ver Documento',
      url: Bases_pdf,
    },
    {
      titulo: 'Resultados Finales',
      icon: ResultFinal_icon,
      nombre: 'Ver Documento',
      url: ResultFinal_pdf,
    },
  ];
  return(
    <section className='cas-section'>
      <div className='titulo-cas'>
        <img src={brocoli_icon} className='titulo-icon'></img>
        <h2>Concurso Fruti-Verdura 2025</h2>
      </div>
      <p className='subtitulo'>Información sobre el concurso.</p>
      <div className='cas-grid'>
        {documentos.map((doc, index) => (
          <div className='cas-card' key={index}>
            <img src={doc.icon} className='doc-icon'></img>
            <h3>{doc.titulo}</h3>
            <a
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
            >
            {doc.nombre}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};
export default ConcursoFutriVerdura2025;